import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const ConnectCRMPage = lazy(() =>
  import('@/features/settings/crm/ConnectCRMPage').then((m) => ({ default: m.ConnectCRMPage })),
);

export const Route = createFileRoute('/app/settings/connect-crm')({
  component: () => (
    <Suspense>
      <ConnectCRMPage />
    </Suspense>
  ),
});
